import React, { useEffect, useState } from 'react';
import { useTour } from './TourProvider';

const TourTooltip = () => {
  const { isTourActive, currentStep, tourSteps, nextStep, prevStep, endTour } = useTour();
  const [pos, setPos] = useState({ left: 0, top: 0 });

  useEffect(() => {
    if (!isTourActive || !tourSteps[currentStep]?.selector) return;

    const compute = () => {
      const el = document.querySelector(tourSteps[currentStep].selector);
      if (!el) return;
      const rect = el.getBoundingClientRect();
      setPos({
        left: rect.right + 16,
        top: rect.top + rect.height / 2,
      });
    };

    setTimeout(compute, 120);
    window.addEventListener('resize', compute);
    return () => window.removeEventListener('resize', compute);
  }, [isTourActive, currentStep, tourSteps]);

  if (!isTourActive || !tourSteps[currentStep]) return null;

  const step = tourSteps[currentStep];
  const isLastStep = currentStep === tourSteps.length - 1;

  return (
    <div
      className="fixed bg-white rounded-xl shadow-xl border border-gray-200 p-4 z-[9998] w-72 transition-all duration-300"
      style={{ left: pos.left, top: pos.top, transform: 'translateY(-50%)' }}
    >
      {/* Arrow pointing left */}
      <div className="absolute -left-2 top-1/2 -translate-y-1/2 w-0 h-0"
        style={{ borderTop: '8px solid transparent', borderBottom: '8px solid transparent', borderRight: '8px solid white', filter: 'drop-shadow(-2px 0 1px rgba(0,0,0,0.08))' }}
      />

      <div className="flex items-center justify-between mb-2">
        <h3 className="font-semibold text-[14px] text-gray-900">{step.title}</h3>
        <button onClick={endTour} className="text-gray-400 hover:text-gray-600 text-xl leading-none">×</button>
      </div>

      <p className="text-gray-500 text-[13px] mb-4 leading-relaxed">{step.description}</p>

      <div className="flex items-center justify-between">
        <span className="text-[12px] text-gray-400">{currentStep + 1}/{tourSteps.length}</span>
        <div className="flex gap-2">
          {currentStep > 0 && (
            <button onClick={prevStep} className="px-3 py-1.5 text-[13px] text-gray-500 hover:text-gray-800 transition-colors">
              Back
            </button>
          )}
          <button
            onClick={isLastStep ? endTour : nextStep}
            className="px-4 py-1.5 bg-blue-600 text-white text-[13px] rounded-lg hover:bg-blue-700 transition-colors"
          >
            {isLastStep ? 'Done' : 'Next'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default TourTooltip;